// third-party
import { FormattedMessage } from 'react-intl';

// assets
import { DashboardOutlined, GoldOutlined } from '@ant-design/icons';

// type
import { NavItemType } from 'layout/mantis/types/MenuType';

// icons
const icons = {
	dashboardOutlined: DashboardOutlined,
	goldOutlined: GoldOutlined
};

// ==============================|| MENU ITEMS - DASHBOARD ||============================== //

const dashboard: NavItemType = {
	id: 'item-dashboard',
	title: 'Dashboard',
	type: 'item',
	icon: icons.dashboardOutlined,
	breadcrumbs: false,
	url: '/dashboard'
	// children: [
	// {
	//     id: 'default-dashboard',
	//     title: 'Default',
	//     type: 'item',
	//     url: '/dashboard/analytics',
	//     icon: icons.dashboardOutlined,
	//     breadcrumbs: false
	// },
	// {
	//     id: 'default-dashboard',
	//     title: 'Default',
	//     type: 'item',
	//     url: '/dashboard/default',
	//     icon: icons.dashboardOutlined,
	//     breadcrumbs: true
	// },
	// {
	//     id: 'analytics-dashboard',
	//     title: 'Analytics',
	//     type: 'item',
	//     url: '/dashboard/analytics',
	//     icon: icons.goldOutlined,
	//     breadcrumbs: false
	// }
	// ]
};

export default dashboard;
